import React from 'react';
import { Box } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const VegNonVegBadge = ({ isVeg, isNonVeg }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            {isVeg && (
                <Box
                    sx={{
                        position: 'relative',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '15px',
                        height: '15px',
                    }}
                >
                    <CircleIcon style={{ color: 'green', fontSize: '10px', zIndex: 2 }} />
                    <Box
                        sx={{
                            position: 'absolute',
                            width: '18px',
                            height: '19px',
                            border: '2px solid green',
                            backgroundColor: 'transparent',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            borderRadius: '5px',
                        }}
                    />
                </Box>
            )}

            {isNonVeg && (
                <Box
                    sx={{
                        position: 'relative',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '20px',
                        height: '20px',
                        overflow: 'visible',
                    }}
                >
                    <ArrowDropUpIcon
                        style={{
                            color: 'red',
                            fontSize: '22px',
                            zIndex: 2,
                            position: 'absolute',
                            top: '-0.2px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                        }} />
                    <Box
                        sx={{
                            position: 'absolute',
                            width: '19px',
                            height: '19px',
                            border: '2px solid red',
                            backgroundColor: 'transparent',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            borderRadius: '5px',
                        }}
                    />
                </Box>
            )}
        </Box>
    );
};

export default VegNonVegBadge;
